import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const officeItemsAdapter = createEntityAdapter({})

const initialState = officeItemsAdapter.getInitialState()

export const officeItemsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOfficeItems: builder.query({
            query: (filter) => ({
                url: '/officeitems',
                params: filter,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError;
                },
            }),
            transformResponse: responseData => {
                const loadedOfficeItems = responseData.map(item => {
                    item.id = item._id
                    return item
                });
                return officeItemsAdapter.setAll(initialState, loadedOfficeItems)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'OFFICE_ITEMS', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'OFFICE_ITEMS', id }))
                    ]
                } else return [{ type: 'OFFICE_ITEMS', id: 'LIST' }]
            }
        }),
        getOfficeItemById: builder.query({
            query: (id) => ({
                url: `/officeitems/${id}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError;
                },
            }),
            transformResponse: responseData => {
                responseData.id = responseData._id;
                return responseData;
            },
            providesTags: (result, error, id) => [{ type: 'OFFICE_ITEMS', id }]
        }),
        addNewOfficeItem: builder.mutation({
            query: initialItemData => ({
                url: '/officeitems',
                method: 'POST',
                body: {
                    ...initialItemData,
                }
            }),
            invalidatesTags: [
                { type: 'OFFICE_ITEMS', id: "LIST" }
            ]
        }),
        updateOfficeItem: builder.mutation({
            query: itemData => ({
                url: '/officeitems',
                method: 'PUT',
                body: {
                    ...itemData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'OFFICE_ITEMS', id: arg.id || 'LIST' }
            ]
        }),
        deleteOfficeItem: builder.mutation({
            query: ({ id }) => ({
                url: `/officeitems`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'OFFICE_ITEMS', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetOfficeItemsQuery,
    useGetOfficeItemByIdQuery,
    useAddNewOfficeItemMutation,
    useUpdateOfficeItemMutation,
    useDeleteOfficeItemMutation
} = officeItemsApiSlice

// returns the query result object
export const selectOfficeItemsResult = officeItemsApiSlice.endpoints.getOfficeItems.select()

// creates memoized selector
const selectOfficeItemsData = createSelector(
    selectOfficeItemsResult,
    itemsResult => itemsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllOfficeItems,
    selectById: selectOfficeItemById,
    selectIds: selectOfficeItemIds
    // Pass in a selector that returns the items slice of state
} = officeItemsAdapter.getSelectors(state => selectOfficeItemsData(state) ?? initialState) 